import { Upload } from 'antd'
import { FormItem } from 'components/Select'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'
import Flex from '../../../../../../components/Flex'
export const FileNameDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: #b7bfc7;
  text-align: center;
`
export const NumberInputDiv = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 25px;
`
export const NumberDiv = styled.div`
  display: flex;
  flex-direction: row;

  gap: 5px;
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
    min-width: 10vw;
  }
`
export const NumberDivision = styled.div`
  padding-top: 10px;
`

export const FlexWrapperDiv = styled.div`
  display: flex;
  flex-direction: row;
  gap: 30px;
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
    min-width: 10vw;
  }
`
export const LabelDiv = styled.div`
  width: 100%;
  position: relative;
  font-weight: 600;
  font-size: 12px;
  font-family: 'Plus Jakarta Sans';
  letter-spacing: 0.01em;
  color: rgb(112, 112, 112) !important;
  margin-bottom: -20px;
`

export const LabelDivWithPopup = styled.div`
  width: 100%;
  position: relative;
  font-weight: 600;
  font-size: 12px;
  font-family: 'Plus Jakarta Sans';
  letter-spacing: 0.01em;
  color: rgb(112, 112, 112) !important;
  margin-bottom: -20px;
  .ant-picker-dropdown {
    top: 78px !important;
  }
  .ant-picker-time-panel .ant-picker-content {
    height: 175px;
  }
`

export const DateDiv = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`
export const TimeDiv = styled.div`
  padding-top: 20px;
`
export const AddNewDiv = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  padding-top: 5px;
  position: relative;
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 0.01em;
  color: rgb(112, 112, 112) !important;
  gap: 10px;
`
export const StyledSpan = styled.span`
  color: blue;
  position: relative;
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 0.01em;
  cursor: pointer;
`
export const StyledUpload = styled(Upload)`
  .ant-upload {
    width: 100%;
  }
  .ant-upload-list-item {
    margin-bottom: 30px;
  }

  .ant-upload-list-item-error,
  .ant-upload-list-item-error .ant-upload-text-icon > .anticon,
  .ant-upload-list-item-error .ant-upload-list-item-name {
    color: #323538;
  }
  .ant-upload-list-item-info {
    height: 100%;
    border: 2px #3249d7 solid;
    border-radius: 10px;
  }
  .ant-upload-list {
    width: 100%;
  }
  .ant-upload-list-item-error .ant-upload-list-item-card-actions .anticon {
    color: #cccfd6;
  }
  .ant-upload-list-item-info {
    padding-left: 2%;
  }
  .ant-upload-list {
    width: 100%;
  }
  .ant-upload-list-item-error .ant-upload-list-item-card-actions .anticon {
    color: #cccfd6;
  }
  .ant-upload-list-item-info {
    height: 50px !important;
  }
`
export const UploadFlex = styled(Flex)`
  margin: 25px 0 20px 0;
  border: 1px dashed ${COLORS.BLUE_T_80};
  border-radius: 8px;
  background: ${COLORS.BLUE_T_97};
  height: 150px;

  padding: 30px;
  cursor: pointer;
`
export const UploadIconDiv = styled.div`
  margin-bottom: 15px;
  text-align: center;
`
export const UploadFileDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_BASE};
  line-height: 20px;
  color: #30475e;
  margin-bottom: 5px;
  text-align: center;
`

export const IconWrap = styled(Flex)`
  margin-bottom: ${props => (props.noBottom ? '0px' : '10px')};
  cursor: pointer;
  align-items: center;
`
export const MulitiSelectsboxes = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
`
export const RedNote = styled.div`
  color: rgb(245, 34, 45);
  margin-top:1px;
  font-size: 14px;
  font-weight: 500;
  word-break: break-all;
`
export const MultipleLink = styled(FormItem)`
  .ant-form-item-control-input-content {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
`
export const AddNewCorporate = styled.div`
font-size: 12px;
font-weight: 500;
line-height: 15.12px;
color: #999FAC;

span{
cursor: pointer;
font-size: 12px;
font-weight: 700;
line-height: 15.12px;
color: #3249D7;
}

`